import { Button, Card, CardContent } from "@devhop/ui";
import { FileText } from "lucide-react";
import type { PolicyItemDTO } from "@/modules/document-portal/domain/contracts";

type PolicyDocumentCardProps = {
  item: PolicyItemDTO;
  onView?: (id: string) => void;
  onDownload?: (id: string) => void;
};

export function PolicyDocumentCard({
  item,
  onView,
  onDownload,
}: PolicyDocumentCardProps) {
  const description = item.content?.trim() ?? "";

  return (
    <Card className="overflow-hidden transition-colors hover:border-black/30">
      <CardContent className="p-4 py-0">
        <div className="mb-3 flex items-start justify-between">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-black/5">
              <FileText className="size-5 text-black" />
            </div>
            <div className="min-w-0">
              <h4 className="font-semibold text-base">{item.title}</h4>
              {item.policyType ? (
                <p className="mb-1 font-medium text-muted-foreground text-xs uppercase tracking-wide">
                  {item.policyType}
                </p>
              ) : null}
            </div>
          </div>
          {item.version ? (
            <span className="shrink-0 rounded bg-muted px-2 py-0.5 font-medium text-muted-foreground text-xs">
              v{item.version}
            </span>
          ) : null}
        </div>
        <p className="mb-2 text-muted-foreground text-xs">
          ມີຜົນບັງຄັບໃຊ້: {item.effectiveDate}
        </p>
        {description ? (
          <div className="mb-4 min-h-[2.5rem]" title={description}>
            <p className="line-clamp-2 text-muted-foreground text-xs leading-relaxed">
              {description}
            </p>
          </div>
        ) : null}
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            className="flex-1 border-black font-medium hover:bg-black hover:text-white"
            onClick={() => onView?.(item.id)}
          >
            ອ່ານ
          </Button>
          {onDownload && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDownload(item.id)}
            >
              ດາວໂຫລດ
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
